import React from "react";
import { Typography } from "@mui/material";
import { Box } from "@mui/system";

export const FieldHeader = (props) => {
  return (
    <Box
      sx={{
        border: '1px solid #D9D9D9',
        borderBottom: 0,
        borderRadius: '0.2em 0.2em 0 0',
      }}
    >
      <Box
        style={{
          backgroundColor: "#f1f1f1",
          borderRadius: "0.2em 0.2em 0 0",
        }}
      >
        <Typography variant="h6" sx={{ p: 1.5, fontSize: '16px' }}>
          {props?.title
            ? props?.title.split("*").map((text, index, array) => (
                <React.Fragment key={index}>
                  {text}
                  {index !== array.length - 1 && (
                    <span style={{ color: "#E23939" }}>*</span>
                  )}
                </React.Fragment>
              ))
            : props.headerLabel?.split("*").map((text, index, array) => (
                <React.Fragment key={index}>
                  {text}
                  {index !== array.length - 1 && (
                    <span style={{ color: "#E23939" }}>*</span>
                  )}
                </React.Fragment>
              ))}
        </Typography>
      </Box>
    </Box>
  );
};
